import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import React, { Component } from "react";
import {
  Box,
  Button,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Container, Stack } from "@mui/system";
import DataTable from "react-data-table-component";
import { columns } from "./resources/Cols";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { app } from "./resources/firebase";
import CRUDfirebase from "./CRUDfirebase";
import { collection, getDocs, getFirestore, query } from "firebase/firestore";
// Import the functions you need from the SDKs you need
const firebaseConfig = {
  apiKey: "AIzaSyDD78pbzcmUn5ODnIeMoUhjwdBKd1-rOrQ",
  authDomain: "dai-umsa-bo-abstracts.firebaseapp.com",
  projectId: "dai-umsa-bo-abstracts",
  storageBucket: "dai-umsa-bo-abstracts.appspot.com",
  messagingSenderId: "819109333615",
  appId: "1:819109333615:web:a8144f898cf1dc8ccc5b9a",
  measurementId: "G-1G89RF2S9B",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
let data = [];
getDocs(query(collection(db, "resumenes"))).then((querySnapshot) => {
  const resumenes = [];
  querySnapshot.forEach((doc) => {
    resumenes.push(doc.data());
  });
  data = resumenes;
});
export default class App extends Component {
  state = {
    data: data,
    nombre: "",
    tipo: "",
    descripcion: "",
    modal: false,
    gestion: new Date().getFullYear() + "",
    fade: false,
    email: "",
    password: "",
  };
  componentDidMount() {
    getDocs(query(collection(db, "resumenes"))).then((querySnapshot) => {
      const resumenes = [];
      querySnapshot.forEach((doc) => {
        resumenes.push(doc.data());
      });
      this.setState({
        data: resumenes.sort((a, b) => {
          if (a.gestion < b.gestion) return 1;
          if (a.gestion > b.gestion) return -1;
          return 0;
        }),
      });
    });
  }
  async onChangeSearchField(param, field) {
    let fieldN = field;
    if (typeof fieldN === "object") fieldN = field.$y + "";
    await this.setState({
      [param]: fieldN,
    });
    this.filterData(param, this.state[param]);
  }
  filterData(param, field) {
    const convert = (f) => {
      if (typeof f === "number" || "object") return (f + "").toLowerCase();
      return f.toLowerCase();
    };
    const newData = data.filter((item) =>
      convert(item[param]).includes(convert(field))
    );
    this.setState({
      data: newData,
    });
  }
  async openModal() {
    await this.setState({
      modal: true,
    });
  }
  async closeModal() {
    await this.setState({
      modal: false,
    });
  }
  render() {
    return (
      <Typography>
        <Container
          sx={{ py: 4, my: 4, backgroundColor: "white", borderRadius: "1rem" }}
        >
          <Modal
            open={this.state.modal}
            onClose={() => {
              this.closeModal();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ overflow: "auto" }}
          >
            <Typography>
              <Container
                sx={{
                  py: 4,
                  mx: "auto",
                  my: 4,
                  backgroundColor: "white",
                  borderRadius: 2,
                }}
              >
                {!this.state.fade ? (
                  <>
                    <Fade
                      in={!this.state.fade}
                      style={{
                        transitionDelay: this.state.fade ? "350ms" : "0ms",
                      }}
                    >
                      <Box
                        sx={{
                          border: 2,
                          borderStyle: "solid",
                          borderColor: "rgb(1, 1, 1, 0.25)",
                          borderRadius: 2,
                          p: 2,
                          width: "fit-content",
                          mx: "auto",
                        }}
                      >
                        <Stack alignItems="center" spacing={2}>
                          <TextField
                            onChange={(e) => {
                              this.setState({
                                email: e.target.value,
                              });
                            }}
                            value={this.state.email}
                            label="E-mail"
                            size="small"
                          />
                          <TextField
                            onChange={(e) => {
                              this.setState({
                                password: e.target.value,
                              });
                            }}
                            value={this.state.password}
                            type="password"
                            label="Contraseña"
                            size="small"
                          />
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => {
                              const auth = getAuth(app);
                              signInWithEmailAndPassword(
                                auth,
                                this.state.email,
                                this.state.password
                              )
                                .then((userCredential) => {
                                  // Signed in
                                  this.setState({
                                    fade: true,
                                  });
                                  // ...
                                })
                                .catch((error) => {
                                  console.log("Error de sesión");
                                });
                            }}
                          >
                            Iniciar sesión
                          </Button>
                        </Stack>
                      </Box>
                    </Fade>
                  </>
                ) : (
                  <></>
                )}
                {this.state.fade ? (
                  <>
                    <Fade
                      in={this.state.fade}
                      style={{
                        transitionDelay: this.state.fade ? "350ms" : "0ms",
                      }}
                    >
                      <Container>
                        <Tooltip title="Cerrar sesión">
                          <IconButton
                            sx={{ float: "left" }}
                            onClick={() => {
                              const auth = getAuth(app);
                              signOut(auth)
                                .then(() => {
                                  this.setState({
                                    fade: !this.state.fade,
                                  });
                                })
                                .catch((error) => {
                                  console.log(
                                    "Error al intentar cerrar sesión"
                                  );
                                });
                            }}
                          >
                            <LogoutIcon fontSize="large" />
                          </IconButton>
                        </Tooltip>
                        <CRUDfirebase auth={app} />
                      </Container>
                    </Fade>
                  </>
                ) : (
                  <></>
                )}
              </Container>
            </Typography>
          </Modal>
          <Button
            sx={{ float: "right" }}
            size="small"
            variant="outlined"
            onClick={() => {
              this.openModal();
            }}
          >
            DAI
          </Button>
          <Stack alignItems="center" spacing={2}>
            <Typography variant="h3">RESÚMENES EJECUTIVOS</Typography>
            <Typography color="text.secondary" variant="h5">
              Filtros
            </Typography>
            <Stack direction="row" spacing={4}>
              <TextField
                sx={{ width: "100%" }}
                onChange={(e) => {
                  this.onChangeSearchField("nombre", e.target.value);
                }}
                label="Buscar por título"
                value={this.state.searchField}
              />
              <TextField
                sx={{ width: "100%" }}
                onChange={(e) => {
                  this.onChangeSearchField("descripcion", e.target.value);
                }}
                label="Buscar por código"
                value={this.state.searchField}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Tipo de documento
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.tipo}
                  label="Tipo de documento"
                  onChange={(e) => {
                    this.onChangeSearchField("tipo", e.target.value);
                  }}
                >
                  <MenuItem value={""}>Vacío</MenuItem>
                  {Array.from(new Set(data.map((item) => item.tipo))).map(
                    (type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year"]}
                  label="Gestión"
                  value={this.state.gestion}
                  onChange={(e) => {
                    this.onChangeSearchField("gestion", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      helperText={null}
                      sx={{ width: 450 }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Stack>
            <DataTable
              data={this.state.data}
              columns={columns}
              pagination
              fixedHeader
              responsive
            />
          </Stack>
        </Container>
      </Typography>
    );
  }
}
